<template>
	<div>
		<ReFileUpload 
			v-model="photos"
			:type="'file'"
			:multiple="true"
			:formId="typeof value == 'undefined' || value == '' ?'passupload_01'+'_'+Math.random():'passupload_'+value+'_'+Math.random()"
			acceptMime="*/*"
			:uploadApi="uploadApi"
			:delApi="delApi"
			:src_filenames="src_filenames"
			v-on:change="OnUploadFile"
		/>
	</div>
</template>

<script>
	import ReFileUpload from 'src/our_components/ReFileUpload.vue';

	export default {
		name: 'RePassportPhotos',
		components: {
			ReFileUpload
		},
		props: {
			value: [Number,String, Object], // client_id
			findId: { //это свойсво удалять не надо, оно хорошее и моет быть использовано в опуиях для формпринтера или фильтрпринтера
				type: String,
				default: '',
			},
			uploadApi:{
				type: Object,
				default: function(){
					return {'apiMethod':'UniUpload', 'apiParam':{'obj':'FileUpload','flt':{'type':'passport_files','client_id':this.value}}};
				}
			},
			delApi:{
				type: Object,
				default: function(){
					return {'apiMethod':'DEL_PASSPORT','apiParam':{'obj':'client','flt':{'id':this.value,'client_id':this.value}}};
				}
			},
			strFilePath:{
				type: String,
				default: '/DATA/pass/file/',
			},
			strGetMethod:{
				type: String,
				default: 'GET_PASSPORT',
			},
			state: {
				type: Object,
				default: function(){
					return {'isFiles':false,'iFileCount':0};
				}
			},
		},
		data () {
			return {
				ver: 1,
				//uploadApi: {'apiMethod':'UniUpload', 'apiParam':{'obj':'FileUpload','flt':{'type':'passport_files','client_id':this.value}}},
				//delApi:{'apiMethod':'DEL_PASSPORT','apiParam':{'obj':'client','flt':{'id':this.value}}},
				//strFilePath: '/DATA/pass/file/',
				photos:[],
				src_filenames:[],
				bUploading: false,
			}
		},
		watch:{
			value(val){
				this.uploadApi.apiParam.flt.client_id = this.value;
				this.delApi.apiParam.flt.client_id = this.value;
				this.GetPassportPhotos();
			}
		},
		computed: {

		},
		methods: {
			OnUploadFile(objUpload){
				//console.log(objUpload);
				if(typeof objUpload == 'string' && objUpload == '')this.photos=[];
				if(objUpload == null) return false;
				if(typeof objUpload.selfObj != 'undefined'){
					if(!this.$GVO.isEmpty(objUpload.selfObj.uploadApi)){
						this.bUploading=true;
						const objIndex = objUpload.formId.match(/[0-9/.]+/)[0];
						this.$GVO.UploadFile(objUpload.formId, objUpload.selfObj.uploadApi.apiMethod, objUpload.selfObj.uploadApi.apiParam)
							.then(objApi => {
								//console.log(objApi);
								if(objApi.success){
									for (let i = 0; i < objApi.data.length; i++) {
										this.photos.push(objApi.data[i].fullpath);
										this.src_filenames.push(objApi.data[i].src_filename);
									}
									this.GetPassportPhotos();
								}else{
									// console.log(objApi.msg);
									this.$GVO.showAlert('Загрузка файлов',objApi.msg);
								}
								this.bUploading=false;
							})
							.catch(errorObjApi => 	{  console.error(errorObjApi); this.bUploading=false;});
					}
				}
			},
			GetPassportPhotos(){
				if(typeof this.value != 'undefined' && this.value != '') {
					this.src_filenames=[];
					this.$GVO.ApiCall(this.strGetMethod,{obj:'client' ,flt:{id:this.value}})
					.then((objApi) => { 
						if(objApi.success === true){
							//console.log(objApi.data);
							let masFilePaths = [];
							if(objApi.data.length > 0){
								for (let i = 0; i < objApi.data.length; i++) {
									masFilePaths.push(this.strFilePath+objApi.data[i].filename);
									let src_filename = objApi.data[i].filename;
									if(objApi.data[i].src_filename!='')src_filename = objApi.data[i].src_filename;
									this.src_filenames.push(src_filename);
								}
								this.state.isFiles = true;
							}
							this.state.iFileCount = masFilePaths.length;
							if(this.state.iFileCount<=0)this.state.isFiles = false;
							this.photos = masFilePaths;
						}
					}).catch(errorObjApi => {console.error(errorObjApi);});
				}
			}
		},
		mounted(){
			this.GetPassportPhotos();
		}
	}
</script>
<style scoped>

</style>
